.tr:not(:last-child) {
  border-bottom: 1px solid var(--static-divider-standard);
  height: 4rem;
  margin-left: 5px;
}

.tr:last-child {
  border-bottom: 0px;
}

.th {
  border-bottom: 1px solid var(--static-divider-standard);
  text-align: left;
  vertical-align: middle;
}

.thead {
  height: 4rem;
}

.listingSkuContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
}

.filterButtons {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.filterButtonIcons {
  fill: var(--static-text-standard);
}

.inventoryImage {
  margin-left: 30px;
  margin-top: 5px;
  border-radius: 8px;
}

.dropdownContainer {
  margin-right: 30px;
}

.dropdownButtonIcon {
  color: var(--static-text-standard);
  font-size: 24px;
  cursor: pointer;
}

.inventoryItemName {
  display: inline-block;
  max-width: 20rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-decoration: none;
  color: inherit;
  cursor: pointer;
}

.sortChip {
  padding: 3px;
  border: 1px solid var(--static-divider-standard);
  border-radius: 10px;
}

.table {
  width: 100%;
  background-color: var(--static-background-standard);
  border-radius: 10px;
  border-collapse: collapse;
}

.inventoryItemTitle {
  min-width: 0;
  max-width: 20rem;
}

.dropdownButton {
  border: 1px solid var(--static-divider-standard);
  border-radius: 0.375rem;
  padding: 0 1rem;
  color: var(--static-text-strong);
}

.filterDropdownInputRow {
  margin-bottom: 1rem;
  justify-content: space-between;
}

.filterDropdownNumberInput {
  flex: 0 1 5rem;
}

.filterAutocomplete {
  flex: 1;
}

.filterDropdownChip {
  border: 1px solid var(--static-divider-standard);
  border-radius: 0.375rem;
  padding: 0.25rem;
}

.filterDropdown {
  background-color: var(--static-background-weak);
  border: 1px solid var(--static-divider-standard);
  border-radius: 0.375rem;
  padding: 1rem;
}

.overflowText {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--static-text-strong);
}

.searchAndImportContainer {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.tableActionContainer {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}

.searchInput {
  margin-bottom: 0 !important;
}

.headerControlButton {
  text-wrap: nowrap;
}

.searchInputContainer {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
}

.listingProductContainer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.listingItem {
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 1rem;
  padding: 0.5rem 0;
  text-align: left;
  overflow: hidden;
}

.listingImage {
  width: 60px;
  height: 60px;
  border-radius: 0.5rem;
  object-fit: cover;
  object-position: center;
}

.listingItemDetail {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  min-width: 0;
  gap: 0.5rem;
}

.listingItemSkuDetail {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  gap: 0.2rem;
}

.listingItemSubDetail {
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 0.5rem;
  text-align: left;
}

.listingName {
  color: var(--static-text-standard);
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1;
  max-width: 100%;
}

.listingAsin {
  color: var(--static-text-weak);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1;
}